import { mande } from 'mande'

const globalOptions = {
  headers: {
    'Content-Type': 'application/json'
  },
  after: (response: any) => {
    if (response.status == 401) {
      localStorage.removeItem('session')
      localStorage.removeItem('user')
      document.cookie = 'session=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT'
      window.location.href = '/login'
    }
  }
}

export const api = mande('/api', globalOptions)

// export function setAuthToken(token: string) {
//   if (token == '') {
//     // globalOptions.headers.Authorization = ''
//   } else {
//     // globalOptions.headers.Authorization = 'Bearer ' + token
//   }
// }

export function setAfterHook(hook: (response: any) => void) {
  globalOptions.after = hook
}
